import { CadernoOutputBaseDto } from "./caderno-output-base.dto";
import { ListarEdicoesParaCalendarioOutputDto } from "./listar-edicoes-para-calendario-output.dto";

export interface CadernoHomeOutputDto {
  cadernoEdicaoId: number;
  tipoCaderno: number;
  descricao: string;
  ordem: number;
}

export interface EdicaoHomeOutputDto {
  edicaoId: number;
  dataPublicacao: Date;
  dataHoraPublicacao: Date;
  extra: boolean;
  cadernos: CadernoHomeOutputDto[];
}

export class ObterUltimaEdicaoECalendarioOutputDto {
  dataPublicacaoUltimaEdicao: Date;
  cadernosUltimaEdicao: CadernoOutputBaseDto[];
  edicoesCalendario: ListarEdicoesParaCalendarioOutputDto[];
  edicaoOrdinaria?: EdicaoHomeOutputDto;
  primeiraEdicaoExtra?: EdicaoHomeOutputDto;

  constructor() {
      this.dataPublicacaoUltimaEdicao = new Date();
      this.cadernosUltimaEdicao = [];
      this.edicoesCalendario = [];
  }
}
